module.exports = __webpack_public_path__ + "84ecce3896c6bfb9d2091f2e780cfa7f.pdf";